import * as React from "react";

import { Button, FormField, Input, Modal, ModalPortal, SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { StackingContextLevel } from "styles/stacking-context-level";
import { withVar } from "themes/helpers";

interface IProps {
  subject: string;
  onClose(): void;
  onSubmit(subject: string): void;
}

interface IState {
  subject: string;
}

function isSubjectValid(originalSubject: string, subject: string): boolean {
  const trimmedSubject = subject.trim();
  return trimmedSubject.length > 0 && trimmedSubject !== originalSubject;
}

export class ChangeTicketSubjectModal extends React.Component<IProps, IState> {
  state = {
    subject: this.props.subject,
  };

  private inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleSubmit = () => {
    const { subject } = this.state;
    if (isSubjectValid(this.props.subject, subject)) {
      this.props.onSubmit(subject);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ subject: e.target.value });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { subject: originalSubject, onClose } = this.props;
    const { subject } = this.state;

    return (
      <ModalPortal zIndex={StackingContextLevel.Modal}>
        <Modal
          heading="Change ticket subject"
          onClose={onClose}
          footer={
            <Flex gap={withVar(SpacingToken.Spacing2)}>
              <Button kind="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button kind="primary" onClick={this.handleSubmit} disabled={!isSubjectValid(originalSubject, subject)}>
                Save
              </Button>
            </Flex>
          }
        >
          <form onSubmit={this.handleSubmit}>
            <FormField labelFor="subject" labelText="Ticket subject" css={{ maxWidth: "100%", width: "340px" }}>
              <Input
                ref={this.inputRef}
                maxLength={1000}
                id="subject"
                placeholder="Enter ticket subject…"
                value={subject}
                onChange={this.handleSubjectChange}
              />
            </FormField>
          </form>
        </Modal>
      </ModalPortal>
    );
  }
}
